import clsx from 'clsx';
import Icon from 'components/ui/Icon';
import config from 'config';

type Props = {
  className?: string;
  useLink?: boolean;
  useCountry: () => { country: string };
};

const PhoneBox = ({
  className,
  useLink = true,
  useCountry,
}: Props): JSX.Element => {
  const { country } = useCountry();
  const number =
    config.countries[country as keyof typeof config.countries].phone;
  const AnchorOrDiv = useLink ? 'a' : 'div';

  return (
    <AnchorOrDiv
      className={clsx(
        'inline-flex items-center py-1 px-8 rounded-2xl border-2 border-siam',
        className,
      )}
      href={`tel:${number}`}
    >
      <Icon
        type={`Countries.${country}`}
        height="18px"
        color="#fff"
        className="fill-current"
      />
      <span className="ml-3">{number}</span>
    </AnchorOrDiv>
  );
};

export default PhoneBox;
